(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcp-hero-arrivals"] && !Shopify.designMode) return;
  try {
    
function initArrivals(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const track = root.querySelector('.rcp-hero-track');
  const slides = [...track.children];
  if (slides.length < 2) return;
  const controls = root.querySelector('.rcp-hero-controls');
  const pause = root.querySelector('[data-pause]');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = motion.matches;
  controls.hidden = false;
  const label = () => { pause.textContent = paused ? 'Play rotation' : 'Pause rotation'; };
  const move = step => {
    if (!track.clientWidth) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    track.scrollTo({left: ((index + step + slides.length) % slides.length) * track.clientWidth, behavior: motion.matches ? 'instant' : 'smooth'});
  };
  label();
  pause.addEventListener('click', () => { paused = !paused; label(); });
  root.querySelector('[data-prev]').addEventListener('click', () => move(-1));
  root.querySelector('[data-next]').addEventListener('click', () => move(1));
  const timer = setInterval(() => {
    if (!root.isConnected) { clearInterval(timer); return; }
    if (!paused && !document.hidden && !root.matches(':hover, :focus-within')) move(1);
  }, 6500);
}
document.querySelectorAll('[data-rcp-carousel]').forEach(initArrivals);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rcp-carousel]').forEach(initArrivals));

  } catch(e) { console.error(e); }
})();
})();
